import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Row } from "@faire/web--source/slate/Layout";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import * as React from "react";
import styled from "styled-components";
export var LoginWrapper = function(param) {
    var children = param.children, noSpacing = param.noSpacing;
    var isMobile = useViewport().isMobile;
    if (!isMobile) {
        return /*#__PURE__*/ _jsxs(Wrapper, {
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: 4
                        }),
                        /*#__PURE__*/ _jsx(FaireLogo, {
                            size: 88
                        })
                    ]
                }),
                noSpacing ? null : /*#__PURE__*/ _jsx(Spacer, {
                    size: "4x"
                }),
                children
            ]
        });
    } else {
        return /*#__PURE__*/ _jsx(Wrapper, {
            children: children
        });
    }
};
var Wrapper = styled(Column).withConfig({
    componentId: "sc-48d244a8-0"
})([
    "padding:",
    ";margin-bottom:",
    ";",
    "{margin:auto;min-height:480px;width:420px;padding:",
    ";}"
], getSpacing("5x", "3x", "8x", "3x"), getSpacing("8x"), responsiveMediaQueries.tabletAndAbove, getSpacing("5x"));
